/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import { UpperCasePipe} from '@angular/common';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenCred = 'SESSIONTOKEN';
  private appLanguage = 'lang';
  private cookieStatus = 'gdpr';
  private codeToken = 'codetoken';

  constructor(
    private uppercase: UpperCasePipe,
    private cookieService: CookieService
  ) {}

  getAuthorizationToken(): string {
    return this.cookieService.get(this.tokenCred);
  }

  saveAuthorizationToken(authorizationToken: string) {
    const expiringDate = new Date();
    expiringDate.setHours(expiringDate.getHours() + 1);
    this.cookieService.set(this.tokenCred, authorizationToken, {expires: expiringDate, path: '/'});
  }

  destroyAuthorizationToken() {
    this.cookieService.delete(this.tokenCred);
  }

  getAppLanguage(): string {
    return this.cookieService.get(this.appLanguage);
  }

  /* LANGUAGE CHANGE - CONFIGURE TRANSLATION HERE */
  getAppLanguageAndLocale(): string {
    const cachedLang = this.cookieService.get(this.appLanguage);
    let appLang = '';
    environment.defaultLanguageOrder.forEach(function (value) {
      if (value.indexOf(cachedLang) !== -1) {
        appLang = cachedLang;
      }
    });

    switch (appLang) {
      case 'en':
        return 'en-US';
      case 'hu':
        return 'hu-HU';
      case 'de':
        return 'de-DE';
      default:
        return (environment.defaultLanguage + '-' +
          ((environment.defaultLanguage === 'en') ? 'US' : this.uppercase.transform(environment.defaultLanguage)));
    }
  }

  saveAppLanguage(language: string) {
    this.cookieService.set(this.appLanguage, language, {expires: 365, path: '/'});
  }

  getCookieData(): string {
    return this.cookieService.get(this.cookieStatus);
  }

  isCookieApproved(): boolean {
    return (this.cookieService.get(this.cookieStatus) === 'dismiss');
  }

  saveCookieData(cookieStatus: string) {
    this.cookieService.set(this.cookieStatus, cookieStatus, {expires: 365, path: '/'});
  }

  destroyCookieData() {
    this.cookieService.delete(this.cookieStatus);
  }

  areCookiesEnabled() {
    let cookieEnabled = navigator.cookieEnabled;
    if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
      document.cookie = 'testCookie';
      cookieEnabled = document.cookie.indexOf('testCookie') !== -1;
    }
    return cookieEnabled;
  }

  getCodeToken(): string {
    return this.cookieService.get(this.codeToken);
  }

  saveCodeToken(codeToken: string) {
    const expiringDate = new Date();
    expiringDate.setHours(expiringDate.getMinutes() + 1);
    this.cookieService.set(this.codeToken, codeToken, {expires: expiringDate, path: '/'});
  }

  destroyCodeToken() {
    this.cookieService.delete(this.codeToken);
  }
}
